// Lesson titles pasted one per line. A leading "1.", "1)", "-" or "•" (how lists get copied out of a
// document or a chat) is dropped; blank lines are skipped. The limits are the lesson form's.
const LIST_MARK_RE = /^\s*(?:\d+[.)]|[-•*])\s+/;
export const LESSON_TITLE_MIN = 3;
export const LESSON_TITLE_MAX = 100;

/** → [{ line, title, error: null | 'tooShort' | 'tooLong' }], `line` being 1-based in the paste. */
export function parseLessonTitles(text) {
  return String(text || '')
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map((raw, i) => ({ line: i + 1, title: raw.replace(LIST_MARK_RE, '').trim() }))
    .filter((row) => row.title !== '')
    .map((row) => ({
      ...row,
      error: row.title.length < LESSON_TITLE_MIN
        ? 'tooShort'
        : row.title.length > LESSON_TITLE_MAX ? 'tooLong' : null,
    }));
}
